"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertBlobToObjectUrl = void 0;
const convertBlobToObjectUrl = blob => {
  let url = '';
  const urlCreator = window.URL || window.webkitURL;
  if (blob) {
    url = urlCreator.createObjectURL(blob);
  }
  return url;
};
exports.convertBlobToObjectUrl = convertBlobToObjectUrl;